import { render, staticRenderFns } from "./PoiGroups.vue?vue&type=template&id=4b967947&"
import script from "./PoiGroups.vue?vue&type=script&lang=js&"
export * from "./PoiGroups.vue?vue&type=script&lang=js&"
import style0 from "./PoiGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports